import { render } from "./DirPicker.vue?vue&type=template&id=0d688cbd"
import script from "./DirPicker.vue?vue&type=script&lang=ts"
export * from "./DirPicker.vue?vue&type=script&lang=ts"
script.render = render

export default script